enum ModalTypeEnum {
  ALERT,
  CONFIRM,
  CONFIRM_WITH_FORM,
  INFORMATION,
}

export default ModalTypeEnum;
